import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Responsable commercial',
  [ManagerRole.SalesLeadership]: 'Direction commerciale',
  [ManagerRole.ContentManager]: 'Gestionnaire de contenu',
  [ManagerRole.OnboardingManager]: "Responsable d'intégration",
  [ManagerRole.OccAgent]: "Agent de centre d'appels",
};
